// One mark per activity type, as Sales Copilot draws them in its activity
// feed (`mk-copilot` ActivityFeedWidget/constants.tsx), so a person moving
// between the two products reads the same colour for the same kind of event.
//
// Class strings, not SVG imports: Studio draws its icons through the Font
// Awesome kit in `HTML.tsx`, which is the free set. Copilot's three Pro glyphs
// (globe-pointer, bullhorn, signal-stream) take their nearest free neighbour.

export interface ActivityMark {
  /** A Font Awesome class pair the kit resolves. */
  icon: string;
  /** The glyph's colour. */
  color: string;
  /** The disc behind it. */
  background: string;
}

const MARKS: Record<string, ActivityMark> = {
  'Web Activity': {
    icon: 'fas fa-globe',
    color: '#2d99fd',
    background: '#d9edff',
  },
  'Email Activity': {
    icon: 'fas fa-envelope-open-text',
    color: '#ffa800',
    background: '#ffecb2',
  },
  'App Usage': {
    icon: 'fas fa-desktop',
    color: '#00c080',
    background: '#cbf7e8',
  },
  'Marketing Activity': {
    icon: 'fas fa-bullhorn',
    color: '#ec4899',
    background: '#fad0e5',
  },
  'Sales Activity': {
    icon: 'fas fa-dollar-sign',
    color: '#3f526e',
    background: '#ccd6e5',
  },
  'Social Activity': {
    icon: 'fas fa-rss',
    color: '#8a3ffc',
    background: '#eeddff',
  },
  'Job Activity': {
    icon: 'fas fa-briefcase',
    color: '#ff5e5e',
    background: '#ffdada',
  },
};

const DEFAULT_MARK: ActivityMark = {
  icon: 'fas fa-check',
  color: '#5eded3',
  background: '#baf7ef',
};

/** The mark for an activity type, or the neutral one for a type the map lacks. */
export function activityMark(type: string | null | undefined): ActivityMark {
  return (type && MARKS[type]) || DEFAULT_MARK;
}
